<main class="wrapper">
    <app-accessibility-content></app-accessibility-content>
</main>
